const menu = () => {
  document.addEventListener('click', function (e) {
    target = e.target

    var algoliaElement = target.classList
      ? target.classList.contains('ais-')
      : false

    if (document.body.contains(target)) {
      if (
        !algoliaElement &&
        !target.closest('.slide-out-element__toggle') &&
        !target.closest('.slide-out-element.is-active')
      ) {
        $('.slide-out-element.is-active').removeClass('is-active')
        $('#js-slide-out-gradient').removeClass('js-active')
      }
    }
  })
}

export default menu
